<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">Customer</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 2" step="2">Vehicles</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 3" step="3">Select Products</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 4" step="4">Assign Products</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 5" step="5">Finance</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="step > 6" step="6">Contact</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1" class="pt-5">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete v-model="customer" :items="customerList" :loading="gettingCustomers" label="Select a Customer" item-text="name"
                    hide-details item-value="key">
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step2" :disabled="!customer" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-btn color="primary" @click="addVehicleDialog = true">Add Vehicle</v-btn>
                  <v-btn style="float:right;" color="primary" @click="step3" :disabled="vehicles.length === 0" depressed>Next</v-btn>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="searchVehicles" append-icon="search"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-data-table :items="vehicleList" hide-actions :loading="gettingVehicles" v-model="vehicles" :search="searchVehicles" item-key="id"
                    select-all :headers="[{text:'Row', value: 'index', sortable: false},{text:'Vehicle ID.', value: 'friendlyId', sortable: true},{text:'Vehicle Reg.', value: 'VehicleReg', sortable: true},{text:'Make.', value: 'Make', sortable: true}, {text:'Model.', value: 'Model', sortable: true}, {text:'Year Reg.', value: 'Year', sortable: true}, {text:'Added', value: 'Added', sortable: true}, {text:'Actions', value: 'actions', sortable: false, align: 'right'}]" :pagination.sync="vehiclePagination">
                    <template slot="items" slot-scope="props">
                      <tr @click="props.selected = !props.selected">
                        <td>
                          <v-checkbox primary hide-details :value="props.selected"></v-checkbox>
                        </td>
                        <td>{{props.index + 1}}</td>
                        <td>{{props.item.friendlyId ? props.item.friendlyId : 'TBC' }}</td>
                        <td :style="props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;'">{{ props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC' }}</td>
                        <td>{{props.item.Make}}</td>
                        <td>{{props.item.Model}}</td>
                        <td>{{props.item.Year}}</td>
                        <td>{{props.item.Added|formatDate}}<v-chip v-if="props.item.New == true" color="green" text-color="white" small>New</v-chip></td>
                        <td class="text-xs-right">
                          <v-btn icon class="mx-0" @click.stop="deleteVehicle(props.item)">
                            <v-icon color="pink">delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Your search for "{{ searchVehicles }}" found no results.
                    </v-alert>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step1" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step3" :disabled="vehicles.length === 0" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step4" :disabled="jobsToCreate.length === 0" depressed>Next</v-btn>
                <v-flex xs12>
                  <span class="title">Products to Install</span>
                  <v-spacer></v-spacer>
                  <v-checkbox v-model="onlyShowInstalledDevices"
                   label="Only Show Installed Devices"></v-checkbox>
                  <v-flex v-for="(vehicle, i) in vehicles" :key="i" xs12>
                    <v-card class="elevation-8 ma-4">
                      <v-btn style="float:right;" @click="toggleReg(i)" icon><v-icon>{{ expandedRegs.includes(i) ? 'mdi-minus' : 'mdi-plus' }}</v-icon></v-btn>
                      <v-card-title primary-title>
                        <h1><span v-if="vehicle.VehicleReg">{{vehicle.VehicleReg + ' - '}}</span>{{vehicle.friendlyId}}</h1>
                        <v-flex xs12 v-if="expandedRegs.includes(i)">
                          <h4 v-if="!vehicle.installedDevices || Object.keys(vehicle.installedDevices).length < 1">No Installed Devices</h4>
                          <template v-for="(parent) in parentProducts">
                            <h3 v-if="templates.some(item => { return Object.keys(vehicle.installedDevices).includes(item.id) && item.parent === parent.value }) || !onlyShowInstalledDevices">
                              <v-btn @click="toggleParent(parent.value + i)" flat><v-icon>{{ expandedParentProducts.includes(parent.value + i) ? 'mdi-minus' : 'mdi-plus' }}</v-icon> {{ parent.text }}</v-btn>
                            </h3>
                            <template v-for="(template) in templates" v-if="expandedParentProducts.includes(parent.value + i)">
                              <v-select class="ml-5" v-if="template.parent === parent.value && (Object.keys(vehicle.installedDevices).indexOf(template.id) !== -1 || !onlyShowInstalledDevices)" :key="i + template.id" v-model="vehicle.Actions[template.id]" :label="templatesKeyVal[template.id]" :items="['Service Call', 'Sim Swap', 'De & Re', 'De-Install', 'Re-Install']" multiple chips deletable-chips></v-select>
                            </template>
                          </template>
                        </v-flex>
                      </v-card-title>
                    </v-card>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step2" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step4" :disabled="jobsToCreate.length === 0" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-layout row wrap>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step5" depressed>Next</v-btn>
              </v-layout>
              <v-layout row wrap>
                <v-flex v-for="(job, i) in clonedJobsToCreate" :key="i">
                  <v-card class="elevation-8 ma-4">
                    <v-card-title primary-title>
                      <v-flex xs12>
                        <h3 class="headline mb-0">{{job.vehReg}} - {{templatesKeyVal[job.jobType]}}</h3>
                        <template v-for="action in job.actions"><v-chip :key="action" label small class="pb-1">{{action}}</v-chip></template>
                        <v-textarea
                          v-if="job.actions.indexOf('Service Call') !== -1"
                          v-model="job.requirements"
                          label="Service Call Requirements"
                        ></v-textarea>
                        <template  v-if="job.actions.indexOf('Sim Swap') !== -1">
                          <v-select
                            :items="['Vodafone', 'EE', 'O2']"
                            value="Vodafone"
                            v-model="job.network"
                            label="Network"
                          ></v-select>
                          <v-text-field
                            v-model="job.ICCID"
                            label="ICCID for new SIM"
                            type="number"
                          ></v-text-field>
                          <v-text-field
                            v-model="job.APN"
                            label="APN"
                          ></v-text-field>
                        </template>
                        <template  v-if="job.actions.indexOf('De & Re') !== -1">
                          <v-text-field
                            v-model="job.newReg"
                            label="New Vehicle Reg"
                          ></v-text-field>
                          <v-text-field
                            v-model="job.newMake"
                            label="New Make"
                          ></v-text-field>
                          <v-text-field
                            v-model="job.newModel"
                            label="New Model"
                          ></v-text-field>
                        </template>
                        <template  v-if="job.actions.indexOf('De-Install') !== -1">
                          <v-textarea
                            v-model="job.leaveKit"
                            label="Where to leave kit"
                          ></v-textarea>
                        </template>
                        <template  v-if="job.actions.indexOf('Re-Install') !== -1">
                          <v-textarea
                            v-model="job.getKit"
                            label="Where to collect kit"
                          ></v-textarea>
                        </template>
                      </v-flex>
                    </v-card-title>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step3" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step5" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>
            
            <v-stepper-content step="5">
              <v-layout row wrap>
                <!-- <v-checkbox label="Use the same finance type for all jobs?" v-model="globalFinance" v-if="clonedJobsToCreate.length > 1"></v-checkbox>
                <v-spacer></v-spacer> -->
                <v-btn color="primary" @click="step6" depressed>Next</v-btn>
                <v-flex xs12>
                  <h3 class="title">Finance</h3>
                  <template v-if="!globalFinance && clonedJobsToCreate.length > 1">
                    <v-card>
                      <v-tabs v-model="activeFinanceTab">
                        <v-tab v-for="(job, i) in clonedJobsToCreate" :key="i">
                          {{ job.vehReg }} - {{templatesKeyVal[job.jobType]}}
                        </v-tab>
                      </v-tabs>
                      <v-card-text>
                        <v-window v-model="activeFinanceTab">
                          <v-window-item v-for="(job, i) in clonedJobsToCreate" :key="i">
                            <v-flex xs12>
                              <v-select label="Finance Type" :items="['Chargeable', 'Warranty', 'Unknown']" v-model="job.finance.type"></v-select>
                              <v-text-field label="Customer PO" v-model="job.finance.customerPO"></v-text-field>
                              <v-text-field label="Customer Cost" v-model="job.finance.customerCost" type="number" step="0.01" prefix="£"></v-text-field>
                              <v-text-field label="Engineer Cost" v-model="job.finance.supplierCost" type="number" step="0.01" prefix="£"></v-text-field>
                              <v-text-field label="Hardware Cost" v-model="job.finance.hardwareCost" type="number" step="0.01" prefix="£"></v-text-field>
                            </v-flex>        
                          </v-window-item>
                        </v-window>
                      </v-card-text>
                    </v-card>
                  </template>    
                  <template v-if="globalFinance || clonedJobsToCreate.length <= 1">
                    <v-select label="Finance Type" :items="['Chargeable', 'Warranty', 'Unknown']" v-model="finance.type"></v-select>
                    <v-text-field label="Customer PO" v-model="finance.customerPO"></v-text-field>
                    <v-text-field label="Customer Cost" v-model="finance.customerCost" type="number" step="0.01" prefix="£"></v-text-field>
                    <v-text-field label="Engineer Cost" v-model="finance.supplierCost" type="number" step="0.01" prefix="£"></v-text-field>
                    <v-text-field label="Hardware Cost" v-model="finance.hardwareCost" type="number" step="0.01" prefix="£"></v-text-field>
                  </template>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step4Back" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="step6" depressed>Next</v-btn>
              </v-layout>
            </v-stepper-content>
            
            <v-stepper-content step="6">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-layout row wrap class="mt-3">
                    <h3 class="title">Contact</h3>
                    <v-spacer></v-spacer>
                    <v-btn @click="contactDialog = true" color="primary">Add Contact</v-btn>
                  </v-layout>
                  <v-autocomplete 
                    :items="contacts"
                    v-model="selectedContacts"
                    multiple
                    chips
                    deletable-chips
                    item-text="Name"
                    item-value="id"
                    label="Relevant Contacts"
                    hint="Please select any contacts that are relevant to this project.">
                    <template v-slot:item="data">
                      <template>
                        <v-list-tile-content>
                          <v-list-tile-title>{{data.item.Name}}<template v-for="site in data.item.Site"><v-chip label small class="pb-1" :key="site" v-if="sites[site]">{{sites[site].Name}}</v-chip></template></v-list-tile-title>
                        </v-list-tile-content>
                      </template>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mt-3">
                <v-btn color="primary" @click="step = 5" depressed>Back</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveCtnSheetDialog" depressed>Submit</v-btn>
              </v-layout>
            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>

        <v-card>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex md8>
                <v-card-title>
                  <h3 class="title">Attached Documents</h3>
                  <upload-btn :title="'Attach New Document'" :fileChangedCallback="attachFile">
                    <template slot="icon">
                      <v-icon color="white">mdi-paperclip</v-icon>
                    </template>
                  </upload-btn>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-tile v-for="(fileObj, key) in attachedDocs" :key="fileObj.file.name" two-line>
                      <v-list-tile-action>
                        <v-btn icon color="error" @click="attachedDocs.splice(key, 1)" :disabled="savingCtnSheet">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>
                          <span class="body-2">{{fileObj.file.name}}</span>
                          <span class="caption ml-1">{{fileObj.file.size | formatBytes}}</span>
                        </v-list-tile-title>
                        <v-list-tile-sub-title>
                          <v-progress-linear
                            :value="fileObj.Progress"
                            :color="fileObj.State === 0 ? 'primary' : fileObj.State === 1 ? 'blue' : fileObj.State === 2 ? 'warning' : fileObj.State === 3 ? 'success' : fileObj.State === 4 ? 'error' : 'primary'"></v-progress-linear>
                        </v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <v-dialog v-model="ctnSheetDialog" persistent max-width="450">
          <v-card>
            <v-card-title class="headline">Submit Service Call</v-card-title>
            <v-card-text>
              <v-textarea
                label="Service Call"
                v-model="acceptNote"
                rows="3"
                auto-grow></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" flat @click.native="saveCtnSheet" :loading="savingCtnSheet">Submit</v-btn>
              <v-btn color="grey" flat @click.native="ctnSheetDialog = false" :disabled="savingCtnSheet">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="submittedDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Connection Sheet Submitted</v-card-title>
            <v-card-text>The connection sheet has been submitted for approval by support. Reference No: {{submittedRef}}.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" flat @click.native="reset">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      
      <v-dialog max-width="350" v-model="vehicleRegDialog">
        <v-card>
          <v-card-title class="headline">Update Vehicle Registration</v-card-title>
          <v-card-text>
            <v-text-field v-model="vehicleRegDialogData.Reg" label="Vehicle Reg." @keyup.enter="saveVehicleReg" autofocus ref="updateVehicleRegInput"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="saveVehicleReg" color="success" flat>Save</v-btn>
            <v-btn @click="vehicleRegDialog = false" color="grey" flat>Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <new-vehicle-dialog @vehicleAdded="newVehicleAdded" :dialog.sync="addVehicleDialog" :customer="customer"></new-vehicle-dialog>
        <contact-edit-dialog @getContacts="step6" :contactID="null" :customer="customer" :customers="customerObj" :contactDialog.sync="contactDialog"></contact-edit-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { updateAuditLog, storage, fireStore } from '../firebase'
import moment from 'moment'
import UploadButton from 'vuetify-upload-button'
export default {
  components: {
    'upload-btn': UploadButton
  },
  beforeRouteLeave (to, from, next) {
    const answer = window.confirm('Do you really want to leave? Any changes will be lost!')
    if (answer) {
      next()
    } else {
      next(false)
    }
  },
  data () {
    return {
      activeFinanceTab: null,
      globalFinance: true,
      acceptNote: '',
      username: this.$store.getters.userData.Name,
      step: 1,
      vehiclePagination: {
        sortBy: 'friendlyId',
        descending: true,
        rowsPerPage: -1
      },
      pagination: {
        sortBy: 'VehicleReg',
        rowsPerPage: -1
      },
      onlyShowInstalledDevices: true,
      currencies: [
        {text: '£', value: 'gbp'},
        {text: '€', value: 'euro'}
      ],
      qnq: '',
      finance: {},
      templates: [],
      allItems: {},
      allItemsInstalledDevices: {},
      searchVehicles: '',
      searchVehicleData: '',
      contacts: [],
      contactDialog: false,
      customer: null,
      customerObj: {},
      customerShortName: null,
      vehicles: [],
      existingVehicleData: [],
      newVehicleData: [],
      gettingCustomers: false,
      gettingVehicles: false,
      gettingVehicleData: false,
      vehicleList: [],
      addCustomerDialog: false,
      templateDefaults: {},
      selectedContacts: [],
      submittedRef: null,
      sites: [],
      submittedDialog: false,
      addVehicleDialog: false,
      vehicleRegDialog: false,
      vehicleRegDialogData: {
        Reg: null,
        itemId: null
      },
      clonedJobsToCreate: [],
      ctnSheetDialog: false,
      ctnSheetNote: '',
      attachedDocs: [],
      savingCtnSheet: false,
      expandedRegs: [0],
      parentProducts: [],
      expandedParentProducts: []
    }
  },
  created () {
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchDevices')
    this.getParentProducts()
    this.getTemplates()
  },
  watch: {
    customer (value) {
      if (value) {
        const index = this.customerList.findIndex(customerObj => {
          this.customerObj[customerObj.key] = {customerName: customerObj.name}
          return customerObj.key === value
        })
        this.customerShortName = this.customerList[index]['shortName']
      }
    }
  },
  filters: {
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    },
    formatBytes (bytes) {
      if (bytes == 0) return '0 Bytes'
      var k = 1024
      const dm = 2
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    }
  },
  methods: {
    toggleParent (i) {
      if (this.expandedParentProducts.indexOf(i) !== -1) {
        this.expandedParentProducts.splice(this.expandedParentProducts.indexOf(i), 1)
      } else {
        this.expandedParentProducts.push(i)
      }
    },
    toggleReg (i) {
      if (this.expandedRegs.indexOf(i) !== -1) {
        this.expandedRegs.splice(this.expandedRegs.indexOf(i), 1)
      } else {
        this.expandedRegs.push(i)
      }
    },
    getParentProducts () {
      fireStore.collection('parentProducts').orderBy('name').get()
        .then(snap => {
          snap.forEach(doc => {
            let data = {}
            data.value = doc.id
            data.text = doc.data().name
            this.parentProducts.push(data)
          })
        })
    },
    getCustomers () {
      this.gettingCustomers = true
      fireStore.collection('Customers').get()
      .then(snap => {
        snap.forEach(doc => {
          this.customerList.push({key: doc.id, name: doc.data().customerName, shortName: doc.data().shortName, BDM: doc.data().BDM || null, BDMEmail: doc.data().BDMEmail || null})
        })
        this.customerList.sort(function (a, b) {
          const aName = a.name.toLowerCase()
          const bName = b.name.toLowerCase()
          return aName < bName ? -1 : aName > bName ? 1 : 0
        })
        this.gettingCustomers = false
      })
    },
    getTemplates () {
      fireStore.collection('productType').get()
      .then(snap => {
        let defaults = {}
        snap.forEach(doc => {
          if (doc.id !== '' && doc.data().hidden !== true) {
            let obj = doc.data()
            obj.id = doc.id
            obj.visible = false
            // obj.paymentMethods = []
            // obj.contractTerm = '36months'
            // obj.currency = 'gbp'
            // obj.upfrontPayment = null
            // obj.installationPayment = null
            // obj.rentalPayment = null
            // obj.rentalFrequency = null
            // obj.lessor = null
            // obj.leasePayment = null
            // obj.leaseFrequency = null
            // obj.warranty = null
            this.templates.push(obj)
            defaults[obj.id] = {}
            if (obj.extras) {
              obj.extras.forEach(extra => {
                defaults[obj.id][extra.name] = extra.default
              })
            }
          }
        })
        this.templates.sort((a, b) => {
          return a.Index - b.Index
        })
        this.templateDefaults = Object.assign({}, this.templateDefaults, defaults)
        this.allItems = Object.assign({}, this.allItems, defaults)
      })
    },
    getVehicles () {
      this.gettingVehicles = true
      fireStore.collection('Vehicles').where('Customer', '==', this.customer).get()
      .then(snap => {
        snap.forEach(doc => {
          const data = doc.data()
          this.vehicleList.push(
            {
              id: doc.id,
              VehicleReg: data.VehicleReg,
              Make: data.Make,
              Model: data.Model,
              Year: data.Year,
              devices: data.devices,
              friendlyId: data.friendlyId,
              Added: data.Added,
              New: data.Added > (Date.now() - 86400000),
              installedDevices: data.installedDevices || {},
              Actions: {}
            }
          )
        })
        this.gettingVehicles = false
      })
    },
    deleteVehicle (item) {
      const index = this.vehicleList.findIndex(vehicle => {
        return item.id === vehicle.id
      })
      confirm('Are you sure you want to delete this item?') && fireStore.collection('Vehicles').doc(item.id).delete().then(() => { this.vehicleList.splice(index, 1) })
    },
    step1 () {
      this.step = 1
      this.selectedTemplates = []
    },
    step2 () {
      if (this.step === 1) {
        this.vehicles = []
        this.vehicleList = []
        this.existingVehicleData = []
        this.newVehicleData = []
        this.getVehicles()
      }
      this.step = 2
    },
    step3 () {
      this.step = 3
    },
    step4 () {
      this.clonedJobsToCreate = JSON.parse(JSON.stringify(this.jobsToCreate))
      this.finance = {}
      this.clonedJobsToCreate.forEach(template => {
        template.finance = {}
        this.$set(this.finance, template.jobType, {
          paymentMethods: [],
          contractTerm: '36months',
          currency: 'gbp',
          upfrontPayment: null,
          installationPayment: null,
          rentalPayment: null,
          rentalFrequency: null,
          lessor: null,
          leasePayment: null,
          leaseFrequency: null,
          warranty: null
        })
      })
      this.step = 4
    },
    step4Back () {
      this.step = 4
    },
    step6 () {
      this.step = 6
      fireStore.collection('Sites').where('Customer', '==', this.customer).get()
      .then(snap => {
        this.sites = {}
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.sites[doc.id] = data
        })
      })
      fireStore.collection('Contacts').where('Customer', '==', this.customer).get()
      .then(snap => {
        this.contacts = []
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.contacts.push(data)
        })
      })
    },
    step5 () {
      this.step = 5
    },
    saveCtnSheetDialog () {
      this.ctnSheetNote = ''
      this.ctnSheetDialog = true
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    },
    saveCtnSheet () {
      this.savingCtnSheet = true
      const refNo = this.customerShortName + moment().format('X')
      let promises = []
      let downloadUrls = []
      const storageRef = storage.ref('OrderDocs/' + refNo)
      this.attachedDocs.forEach((fileObj, index) => {
        promises.push(new Promise((resolve, reject) => {
          let uploadTask = storageRef.child(fileObj.file.name).put(fileObj.file)
          uploadTask.on('state_changed', snapshot => {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            this.attachedDocs[index]['Progress'] = progress
            // switch (snapshot.state) {
            //   case storage.TaskState.PAUSED: // or 'paused'
            //     this.attachedDocs[index]['State'] = 2
            //     break
            //   case storage.TaskState.RUNNING: // or 'running'
            //     this.attachedDocs[index]['State'] = 1
            //     break
            // }
          }, error => {
            // Handle unsuccessful uploads
            this.attachedDocs[index]['State'] = 4
            reject(error)
          }, () => {
            // Handle successful uploads on complete
            this.attachedDocs[index]['Progress'] = 100
            this.attachedDocs[index]['State'] = 3
            uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              downloadUrls.push({downloadUrl: downloadURL, name: fileObj.file.name})
              resolve()
            })
          })
        })
        )
      })
      Promise.all(promises).then(val => {
        fireStore.collection('Projects').where('Customer', '==', this.customer).get()
          .then((docRef) => {
            const customerIndex = this.customerList.findIndex(customerListObj => {
              return customerListObj.key === this.customer
            })
            const shortName = this.customerList[customerIndex]['shortName']
            let jobNumbers = []
            let jobNo = ''
            let projectIds = []
            let projectId = ''
            let jobsToCreate = []
            docRef.forEach(doc => {
              let projId = doc.data().projectId
              if (projId) {
                projId = projId.replace(/\D/g, '')
                projectIds.push(projId)
              }
            })
            projectIds = projectIds.sort()
            projectIds = projectIds.reverse()
            if (projectIds.length === 0) {
              projectIds.push(0)
            }
            projectId = projectIds[0]
            projectId = 'SC-' + shortName + this.zeroFill(parseInt(projectId) + 1, 4)

            let dataToSend = {jobType: 'Service Call', CreatedDate: moment().format('YYYY-MM-DD'), supplierPO: this.finance.supplierPO || null, supplierCost: this.finance.supplierCost || null, customerPO: this.finance.customerPO || null, customerCost: this.finance.customerCost || null, Customer: this.customer, projectId: projectId, Status: 'CTN Sheet Approved', notes: this.acceptNote, attachedDocs: downloadUrls, qnq: this.qnq, contacts: this.ctnContacts || []}
            fireStore.collection('Projects').add(dataToSend)
            .then(() => {
              updateAuditLog('add', 'serviceCalls', this.user, null, projectId, 'added new project', dataToSend, this.customer)
              fireStore.collection('Jobs').where('Customer', '==', this.customer).get()
              .then((docRef) => {
                docRef.forEach(doc => {
                  let JobNo = doc.data().JobNo
                  if (JobNo && JobNo.indexOf(shortName) > -1) {
                    JobNo = JobNo.replace(/\D/g, '')
                    jobNumbers.push(JobNo)
                  }
                })
                jobNumbers = jobNumbers.sort()
                jobNumbers = jobNumbers.reverse()
                if (jobNumbers.length === 0) {
                  jobNumbers.push(0)
                }
                jobNo = jobNumbers[0]
                for (let job in this.clonedJobsToCreate) {
                  jobNo++
                  let obj = {
                    Customer: this.customer,
                    Vehicle: this.clonedJobsToCreate[job].vehicleID,
                    Status: 0,
                    templates: [this.clonedJobsToCreate[job].jobType],
                    JobNo: shortName + this.zeroFill(parseInt(jobNo), 4),
                    Project: projectId,
                    ServiceCall: true,
                    actions: this.clonedJobsToCreate[job].actions,
                    CreatedDate: Date.now(),
                    finance: this.globalFinance ? this.finance : {...this.finance, ...this.clonedJobsToCreate[job].finance},
                    hardwareCost: (this.globalFinance ? this.finance.hardwareCost : this.clonedJobsToCreate[job].finance.hardwareCost) || 0,
                    engineerCost: (this.globalFinance ? this.finance.supplierCost : this.clonedJobsToCreate[job].finance.supplierCost) || 0,
                    customerCost: (this.globalFinance ? this.finance.customerCost : this.clonedJobsToCreate[job].finance.customerCost) || 0,
                    chargeable: this.globalFinance ? (this.finance.type === 'Chargeable' ? true : false) : (this.clonedJobsToCreate[job].finance.type === 'Chargeable' ? true : false),
                    requirements: this.clonedJobsToCreate[job].requirements ? this.clonedJobsToCreate[job].requirements : null,
                    network: this.clonedJobsToCreate[job].network ? this.clonedJobsToCreate[job].network : null,
                    ICCID: this.clonedJobsToCreate[job].ICCID ? this.clonedJobsToCreate[job].ICCID : null,
                    APN: this.clonedJobsToCreate[job].APN ? this.clonedJobsToCreate[job].APN : null,
                    newReg: this.clonedJobsToCreate[job].newReg ? this.clonedJobsToCreate[job].newReg : null,
                    newMake: this.clonedJobsToCreate[job].newMake ? this.clonedJobsToCreate[job].newMake : null,
                    newModel: this.clonedJobsToCreate[job].newModel ? this.clonedJobsToCreate[job].newModel : null,
                    leaveKit: this.clonedJobsToCreate[job].leaveKit ? this.clonedJobsToCreate[job].leaveKit : null,
                    getKit: this.clonedJobsToCreate[job].getKit ? this.clonedJobsToCreate[job].getKit : null
                  }

                  let template = this.templates.find(t => { return this.clonedJobsToCreate[job].jobType === t.id })

                  obj.templates = template ? template.devices : undefined

                  if (obj.templates) {
                    jobsToCreate.push(obj)
                  }
                }
                console.log(jobsToCreate)
                let mergedJobsToCreate = []
                jobsToCreate.forEach(function (item) {
                  var existing = mergedJobsToCreate.filter(function (v, i) {
                    return v.Vehicle == item.Vehicle && v.finance.type == item.finance.type
                  })
                  if (existing.length) {
                    var existingIndex = mergedJobsToCreate.indexOf(existing[0])
                    mergedJobsToCreate[existingIndex].templates = mergedJobsToCreate[existingIndex].templates.concat(item.templates)
                    mergedJobsToCreate[existingIndex].products = JSON.parse(JSON.stringify(mergedJobsToCreate[existingIndex].templates.concat(item.templates)))
                    mergedJobsToCreate[existingIndex].hardwareCost = (mergedJobsToCreate[existingIndex].hardwareCost * 1) + (item.hardwareCost * 1)
                    mergedJobsToCreate[existingIndex].engineerCost = (mergedJobsToCreate[existingIndex].engineerCost * 1) + (item.engineerCost * 1)
                    mergedJobsToCreate[existingIndex].customerCost = (mergedJobsToCreate[existingIndex].customerCost * 1) + (item.customerCost * 1)
                    mergedJobsToCreate[existingIndex].finance.hardwareCost = (mergedJobsToCreate[existingIndex].finance.hardwareCost * 1) + (item.finance.hardwareCost * 1) || 0
                    mergedJobsToCreate[existingIndex].finance.engineerCost = (mergedJobsToCreate[existingIndex].finance.engineerCost * 1) + (item.finance.engineerCost * 1) || 0
                    mergedJobsToCreate[existingIndex].finance.customerCost = (mergedJobsToCreate[existingIndex].finance.customerCost * 1) + (item.finance.customerCost * 1) || 0
                  } else {
                    if (typeof item.templates == 'string') {
                      item.templates = [item.templates]
                    }
                    item.products = JSON.parse(JSON.stringify(item.templates))

                    mergedJobsToCreate.push(item)
                  }
                })
                console.log(mergedJobsToCreate)
                for (let obj of mergedJobsToCreate) {
                  if (obj.templates.indexOf('preCheck') === -1 && obj.templates.indexOf('5oJKuVseN0PkmvZeDl0J') === -1) {
                    obj.templates.unshift('preCheck')
                  }
                  if (obj.templates.indexOf('Je2nQqSdazW25XWSGkt3') === -1 && obj.templates.indexOf('5oJKuVseN0PkmvZeDl0J') === -1) {
                    obj.templates.push('Je2nQqSdazW25XWSGkt3')
                  }
                  obj.newMethod = true
                  obj.CreatedDate = Date.now()
                  fireStore.collection('Jobs').add(obj)
                    .then(() => {
                      updateAuditLog('add', 'serviceCalls', this.user, null, projectId, 'added new job', obj, this.customer)
                      this.ctnSheetDialog = false
                      this.savingCtnSheet = false
                      this.step = 1
                      this.$router.push('/Project/' + this.customer)
                    })
                }
              })
            })
          })
      }).catch(error => {
        console.log(error)
        this.savingCtnSheet = false
      })
    },
    reset () {
      this.step = 1
      this.pagination = {
        sortBy: 'VehicleReg'
      }
      this.searchVehicles = ''
      this.searchVehicleData = ''
      this.customer = null
      this.customerShortName = null
      this.vehicles = []
      this.existingVehicleData = []
      this.newVehicleData = []
      this.vehicleList = []
      this.attachedDocs = []
      this.submittedRef = null
      this.submittedDialog = false
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.desserts.slice()
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    toggleGroup (templateId) {
      const index = this.selectedTemplates.findIndex(template => {
        return template.id === templateId
      })
      this.selectedTemplates[index]['visible'] = !this.selectedTemplates[index]['visible']
    },
    changeInstalledDevice (itemId, templateId) {
      const index = this.newVehicleData.findIndex(data => {
        return data.id === itemId
      })
      const existingIndex = this.existingVehicleData.findIndex(data => {
        return data.id === itemId
      })
      if (this.newVehicleData[index]['installedDevices'][templateId]) {
        if (this.existingVehicleData[existingIndex]['devices'][templateId]) {
          this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.existingVehicleData[existingIndex]['devices'][templateId])
        } else {
          this.$set(this.newVehicleData[index]['devices'], templateId, {})
          // this.newVehicleData[index]['devices'][templateId] = {}
          this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], this.templateDefaults[templateId])
          if (templateId === 'IGVjrrgemWhH8zki8yBZ') {
            this.newVehicleData[index]['devices'][templateId]['[Tacho Smart] VU Part Number'] = this.newVehicleData[index]['VUPartNo'] ? this.newVehicleData[index]['VUPartNo'] : ''
          }
        }
      } else {
        delete this.newVehicleData[index]['devices'][templateId]
        delete this.newVehicleData[index]['installedDevices'][templateId]
      }
    },
    newVehicleAdded (newVehicleData) {
      const obj = {
        devices: {},
        id: newVehicleData.id,
        Make: newVehicleData.Make,
        Model: newVehicleData.Model,
        Vehicle: newVehicleData.VehicleReg,
        VehicleReg: newVehicleData.VehicleReg,
        Added: newVehicleData.Added,
        New: true,
        friendlyId: newVehicleData.friendlyId,
        Year: newVehicleData.Year,
        installedDevices: {}
      }
      this.vehicleList.push(obj)
    },
    changeInstalledDeviceAll (templateId) {
      if (this.allItemsInstalledDevices[templateId]) {
        this.allItems[templateId] = {}
        const index = this.templates.findIndex(template => {
          return template.id === templateId
        })
        if (this.templates[index]['extras']) {
          this.templates[index].extras.forEach(extra => {
            // this.allItems[templateId][extra.name] = ''
            this.$set(this.allItems, templateId, {})
            this.allItems[templateId] = Object.assign({}, this.allItems[templateId], this.templateDefaults[templateId])
          })
        }
        this.newVehicleData.forEach((newVehicle, index) => {
          const existingIndex = index
          this.newVehicleData[index]['installedDevices'][templateId] = true
          if (this.existingVehicleData[existingIndex]['devices'][templateId]) {
            this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.existingVehicleData[existingIndex]['devices'][templateId])
          } else {
            this.$set(this.newVehicleData[index]['devices'], templateId, {})
            // this.newVehicleData[index]['devices'][templateId] = {}
            this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], this.templateDefaults[templateId])
            if (templateId === 'IGVjrrgemWhH8zki8yBZ') {
              this.newVehicleData[index]['devices'][templateId]['[Tacho Smart] VU Part Number'] = this.newVehicleData[index]['VUPartNo'] ? this.newVehicleData[index]['VUPartNo'] : ''
            }
          }
        })
      } else {
        this.newVehicleData.forEach((newVehicle, index) => {
          delete this.newVehicleData[index]['devices'][templateId]
          delete this.newVehicleData[index]['installedDevices'][templateId]
        })
      }
    },
    changeExtraAll (templateId, extraName) {
      const val = this.allItems[templateId][extraName]
      this.newVehicleData.forEach((newVehicle, index) => {
        let obj = this.newVehicleData[index]['devices'][templateId]
        obj[extraName] = val
        this.newVehicleData[index]['devices'][templateId] = Object.assign({}, this.newVehicleData[index]['devices'][templateId], obj)
      })
    },
    updateVehicleRegDialog (itemId) {
      const index = this.newVehicleData.findIndex(vehicle => {
        return vehicle.id === itemId
      })
      this.vehicleRegDialogData.Reg = this.newVehicleData[index]['VehicleReg']
      this.vehicleRegDialogData.itemId = itemId
      this.vehicleRegDialog = true
      this.$nextTick(this.$refs.updateVehicleRegInput.focus)
    },
    saveVehicleReg () {
      const newReg = this.vehicleRegDialogData.Reg.toUpperCase().replace(/\s/g, '')
      const vehId = this.vehicleRegDialogData.itemId
      const vehIndex = this.vehicleList.findIndex(vehicle => {
        return vehicle.id === vehId
      })
      if (this.vehicleList[vehIndex]['VehicleReg'] !== newReg) { // Only update firestore if reg has changed
        fireStore.collection('Vehicles').doc(vehId).update({VehicleReg: newReg})
        .then(ref => {
          const index = this.newVehicleData.findIndex(vehicle => {
            return vehicle.id === vehId
          })
          this.newVehicleData[index]['VehicleReg'] = newReg
          this.vehicleList[vehIndex]['VehicleReg'] = newReg
          this.vehicleRegDialogData.itemId = null
          this.vehicleRegDialogData.Reg = null
          this.vehicleRegDialog = false
        })
        .catch(error => {
          console.log(error)
        })
      } else {
        this.vehicleRegDialogData.itemId = null
        this.vehicleRegDialogData.Reg = null
        this.vehicleRegDialog = false
      }
    },
    nextRow (rowIndex, extraName) {
      const nextIndex = parseInt(rowIndex) + 1
      if (nextIndex > this.newVehicleData.length - 1) {
        return
      }
      const ref = this.$refs['edit-' + extraName + '-' + nextIndex][0].$children[0].$refs.activator
      ref.click()
    },
    openEditDialog (rowIndex, extraName) {
      setTimeout(() => {
        const ref = this.$refs['input-' + extraName + '-' + rowIndex]
        this.$nextTick(ref[0].focus())
      }, 300)
    },
    vehiclesAdded (vehicleArr) {
      vehicleArr.forEach(vehicle => {
        vehicle.New = true
        vehicle.Added = Date.now()
        this.vehicleList.push(vehicle)
      })
    },
    attachFile (f) {
      if (f) {
        for (let docKey in this.attachedDocs) {
          if (this.attachedDocs[docKey].file.name === f.name) {
            console.log('file exists')
            alert('File with this name already exists. Either delete the existing file or rename the file you are trying to upload')
            return false
          }
        }
        this.attachedDocs.push({Progress: 0, State: 0, file: f})
      }
    },
    currencySymbolFromVal (val) {
      if (val) {
        const index = this.currencies.findIndex(currency => {
          return val === currency.value
        })
        return this.currencies[index]['text']
      }
      return null
    }
  },
  computed: {
    devices () {
      let vehicles = this.vehicles.map(v => v.id)
      return vehicles
    },
    customerList () {
      return this.$store.getters.customers
    },
    user () {
      return this.$store.getters.userData
    },
    templatesKeyVal () {
      let templatesKeyVal = {}
      for (const template in this.templates) {
        if (this.templates.hasOwnProperty(template)) {
          const element = this.templates[template]
          templatesKeyVal[element.id] = element.name
        }
      }
      return templatesKeyVal
    },
    vehicleDataHeaders () {
      let arr = []
      arr.push({
        align: 'left',
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        sortable: true
      })
      this.selectedTemplates.forEach(template => {
        let className = ['group-header']
        if (template.visible) {
          className.push('show')
        }
        let hasExtras = false
        let hasSalesExtra = false
        for (let key in template.extras) {
          if (template.extras[key].permissions.sales === 'write') {
            hasSalesExtra = true
            break
          }
        }
        if (template.extras) {
          hasExtras = true
        }
        arr.push({
          align: 'left',
          text: template.name,
          value: template.id,
          sortable: true,
          width: '50px',
          class: className,
          hasExtras: hasExtras && hasSalesExtra
        })
        if (template.extras && template.visible) {
          template.extras.forEach(templateExtra => {
            if (templateExtra.permissions.sales === 'write') {
              arr.push({
                text: templateExtra.name,
                value: templateExtra.name,
                sortable: true,
                class: 'col-' + template.id,
                align: 'left'
              })
            }
          })
        }
      })
      return arr
    },
    selectedTemplates () {
      let selectedTemplates = []
      this.finance = {}
      this.templates.forEach(template => {
        if (template.checked) {
          this.$set(this.finance, template.id, {
            paymentMethods: [],
            contractTerm: '36months',
            currency: 'gbp',
            upfrontPayment: null,
            installationPayment: null,
            rentalPayment: null,
            rentalFrequency: null,
            lessor: null,
            leasePayment: null,
            leaseFrequency: null,
            warranty: null
          })
          selectedTemplates.push(template)
        }
      })
      return selectedTemplates
    },
    jobsToCreate () {
      let jobs = []
      for (let vehicle in this.vehicles) {
        for (let job in this.vehicles[vehicle].Actions) {
          if (this.vehicles[vehicle].Actions[job].length > 0) {
            jobs.push(
              {
                vehicleID: this.vehicles[vehicle].id,
                jobType: job,
                vehReg: this.vehicles[vehicle].VehicleReg !== undefined ? this.vehicles[vehicle].VehicleReg : this.vehicles[vehicle].friendlyId,
                actions: this.vehicles[vehicle].Actions[job]
              }
            )
          }
        }
      }
      return jobs
    }
  }
}
</script>
<style>
  .v-datatable thead th.column.sortable.active.desc i.group-hide-icon {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
}
.v-datatable thead th.column.sortable i.group-hide-icon {
    font-size: inherit;
    vertical-align: inherit;
    display: inherit;
    opacity: inherit;
    transition: inherit;
}

.v-datatable thead th.column.group-header {
  white-space: normal;
}
</style>


// WEBPACK FOOTER //
// ServiceCalls.vue?4cca7ded